import { render } from "./TheGlobalHeader.vue?vue&type=template&id=d5cf8884&scoped=true&ts=true"
import script from "./TheGlobalHeader.vue?vue&type=script&lang=ts"
export * from "./TheGlobalHeader.vue?vue&type=script&lang=ts"

import "./TheGlobalHeader.vue?vue&type=style&index=0&id=d5cf8884&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5cf8884"]])

export default __exports__